import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
// import { ALL_ITEM_JEWELRYBOXES } from "./itemJson";
import { Media, MediaContextProvider } from "../../../media";
import ModalDownload from "./modalDownload";

function ItemList(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);
  const [indexImage, setIndexImage] = useState(0);
  const [rangeDesktopImage, setRangeDesktopImage] = useState(0);
  const [rangeImage, setRangeImage] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };


  function getImageIndex(index) {
    setIndexImage(index);
  }
  
  function scrollItem(index, sign){  
    if (sign === 'plus' && index !== props.selectedItem[0].itemDesktopSmall.length - 1) {
      setIndexImage(prevIndex => prevIndex + 1);
      if(rangeImage+3 <= props.selectedItem[0].itemDesktopSmall.length - 1){
        setRangeImage(prevIndex => prevIndex + 1);
      }
      if(rangeDesktopImage+4 <= props.selectedItem[0].itemDesktopSmall.length - 1){
        setRangeDesktopImage(prevIndex => prevIndex + 1);
      }
    }else if(sign === 'minus' && index !== 0) {
      setIndexImage(prevIndex => prevIndex - 1);
      if(rangeImage-3 >= -2){      
        setRangeImage(prevIndex => prevIndex - 1);
      }
      if(rangeDesktopImage-3 >= -2){      
        setRangeDesktopImage(prevIndex => prevIndex - 1);
      }
    }
  }

  function scrollToSendUsMessage(scrollTo) {
		const sendUsMessage = document.getElementById(scrollTo);
		if (sendUsMessage) {
		  const offset = 80;
		  const top = sendUsMessage.getBoundingClientRect().top + window.scrollY - offset;
		  window.scrollTo({
			top,
			behavior: 'smooth'
		  });
		}
	  }

  return (
    <MediaContextProvider>
      <Media greaterThanOrEqual="md"> 
        <div id="listItemPage">          
                <div className="itemDisplayContainer">
                    <div className="allItemContainer">
                        <Image
                            src={asset(`${props.selectedItem[0]?.itemDesktopBig[indexImage]}`)}
                            alt={`${props.selectedItem[0]?.itemName}`}
                            className="img-fluid"
                            width="450"
                            height="450"
                        />
                        <div className="smallItemContaienr">
                          <Image
                                  onClick={()=>scrollItem(indexImage, 'minus')}
                                  src={asset(`/icon/desktopArrowLeft.svg`)}
                                  className="arrow"
                                  alt={`desktopArrowLeft`}                          
                                  width="35"
                                  height="35"                               
                            />    
                          <div className="smallItemDisplay">
                          {
                            props.selectedItem[0]?.itemDesktopSmall.map((itemDesktopSmall, index) => 
                            (
                                index >= rangeDesktopImage && index <= (rangeDesktopImage+3) && 
                                <Image
                                  key={index}
                                  onClick={() => getImageIndex(index)}
                                  src={asset(`${itemDesktopSmall}`)}
                                  alt={`${props.selectedItem[0]?.itemName + index}`}
                                  className={`img-fluid ${index === indexImage? "imageSelectedNow": ""} ${index === 0 ? 'first-img' : index === props.selectedItem[0].itemDesktopSmall.length - 1 ? 'last-img' : ''}`}
                                  width="105"
                                  height="105"
                                />
                              )
                            )
                          }
                
                          </div>
                          <Image
                            onClick={()=>scrollItem(indexImage, 'plus')}
                            src={asset(`/icon/desktopArrowRight.svg`)}
                            className="arrow"
                            alt={`desktopArrowRight`}                          
                            width="35"
                            height="35"                               
                          />   
                        </div>
                    </div>
                    <div className="descriptionItemContainer">
                        <div>
                            <h2>{props.selectedItem[0]?.itemName}</h2>
                            <p>{props.selectedItem[0]?.itemDescription}</p>
                            <ul>
                            {props.selectedItem[0]?.itemDescriptionList?.map((list, index)=>(
                              <li key={index}>{list}</li>
                            ))}
                            </ul>
                        </div>
                        <div className="download">
                            <div className="downloadText">
                                <Image
                                src={asset(`/images/ourMaterial/desktop/downloadMaterials.webp`)}
                                alt={`downloadMaterials`}
                                className="img-fluid"
                                />
                            <div className="downloadInnerText">
                                <p>Download Materials Book</p>
                                <a onClick={showModal}>click here to download</a>
                            </div>
                            </div>
                            <button className="quoteBtn" onClick={() => scrollToSendUsMessage("sendUsMessage")}>Request a quote</button>
                        </div>
                    </div>
                </div>
        </div>
        <ModalDownload isModalVisible={isModalVisible} onModalClose={() => setIsModalVisible(false)} />
      </Media>
      <Media lessThan="md"> 
        <div id="listItemPageMobile">          
                <div>
                  <h2>{props.selectedItem[0]?.itemName}</h2>
                </div>
                <div className="itemDisplayContainer">
                    <div className="allItemContainer">
                        <Image
                            src={asset(`${props.selectedItem[0]?.itemMobileBig[indexImage]}`)}
                            alt={`${props.selectedItem[0]?.itemName}`}
                            className="img-fluid"
                            width="335"
                            height="335"
                        />
                        <div className="smallItemContaienr">
                          <Image
                                  onClick={()=>scrollItem(indexImage, 'minus')}
                                  src={asset(`/icon/desktopArrowLeft.svg`)}
                                  className="arrow"
                                  alt={`desktopArrowLeft`}                          
                                  width="35"
                                  height="35"                               
                            />    
                          <div className="smallItemDisplay">
                          {
                            props.selectedItem[0]?.itemMobileSmall.map((itemMobileSmall, index) => 

                              (
                               index >= rangeImage && index <= (rangeImage+2) && 
                               <Image
                                  key={index}
                                  onClick={() => getImageIndex(index)}
                                  src={asset(`${itemMobileSmall}`)}
                                  alt={`${props.selectedItem[0]?.itemName + index}`}
                                  className={`img-fluid ${index === indexImage? "imageSelectedNow": ""} ${index === 0 ? 'first-img' : index === props.selectedItem[0].itemDesktopSmall.length - 1 ? 'last-img' : ''}`}
                                  width="100"
                                  height="100"
                                />
                              )
                            )
                          }
                
                          </div>
                          <Image
                            onClick={()=>scrollItem(indexImage, 'plus')}
                            src={asset(`/icon/desktopArrowRight.svg`)}
                            className="arrow"
                            alt={`desktopArrowRight`}                          
                            width="35"
                            height="35"                               
                          />   
                        </div>
                    </div>
                    <div className="descriptionItemContainer">
                        <div className="textDescription">
                          <p>{props.selectedItem[0]?.itemDescription}</p>
                          <ul>
                            {props.selectedItem[0]?.itemDescriptionList?.map((list, index)=>(
                              <li key={index}>{list}</li>
                            ))}
                          </ul>
                        </div>
                        <div className="download">
                            <div className="downloadText">
                                <Image
                                src={asset(`/images/ourMaterial/desktop/downloadMaterials.webp`)}
                                alt={`downloadMaterials`}
                                className="img-fluid"
                                />
                            <div className="downloadInnerText">
                                <p>Download Materials Book</p>
                                <a onClick={showModal}>click here to download</a>
                            </div>
                            </div>
                            <button className="quoteBtn" onClick={() => scrollToSendUsMessage("sendUsMessageMobile")}>Request a quote</button>
                        </div>
                    </div>
                </div>
        </div>
        <ModalDownload isModalVisible={isModalVisible} onModalClose={() => setIsModalVisible(false)} />
      </Media>
    </MediaContextProvider>
  );
}

export default ItemList;
